import axios from '@/axios'

class SubjectOfBusinessDataService {  getAllSubjectsOfBusiness(): Promise<any> {
    return axios.get('/subjectOfBusiness/getAllSubjectsOfBusiness')
  }
  getSubjectOfBusinessById(id: any): Promise<any> {
    return axios.get(`/subjectOfBusiness/${id}/get`)
  }
  async add(data: any): Promise<any> {
    // The correct endpoint is /subjectOfBusiness/add (not /subjectOfBusiness/)
    return axios.post('/subjectOfBusiness/add', data)
  }
  update(id: any, data: any): Promise<any> {
    return axios.put(`/subjectOfBusiness/${id}/update`, data)
  }
  delete(id: any): Promise<any> {
    return axios.delete(`/subjectOfBusiness/${id}/delete`)
  }
}
export default new SubjectOfBusinessDataService()